import { useQuery } from '@tanstack/react-query';
import { WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS } from '../constants';
import { fetchWebsiteAnalyticsConversion } from '../services/websiteAnalytics.api';
import type { WebsiteAnalyticsDays } from '../types';

export function useWebsiteAnalyticsConversion(
  days: WebsiteAnalyticsDays,
  productSlug: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['website-analytics', 'conversion', days, productSlug ?? 'all'],
    queryFn: () => fetchWebsiteAnalyticsConversion(days, productSlug),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
